/* tslint:disable */
/* eslint-disable */
/* @relayHash 1bd9c324feddac605701691aca615382 */

import { ConcreteRequest } from "relay-runtime";
export type CreateTranslationAnswerInput = {
    studyRecordId: string;
    exerciseId: string;
    response: Array<string>;
    isCorrect: boolean;
    clientMutationId?: string | null;
};
export type CreateTranslationAnswerMutationVariables = {
    input: CreateTranslationAnswerInput;
};
export type CreateTranslationAnswerMutationResponse = {
    readonly createTranslationAnswer: {
        readonly answer: {
            readonly id: string;
        } | null;
    } | null;
};
export type CreateTranslationAnswerMutation = {
    readonly response: CreateTranslationAnswerMutationResponse;
    readonly variables: CreateTranslationAnswerMutationVariables;
};



/*
mutation CreateTranslationAnswerMutation(
  $input: CreateTranslationAnswerInput!
) {
  createTranslationAnswer(input: $input) {
    answer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateTranslationAnswerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createTranslationAnswer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTranslationAnswerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "answer",
        "storageKey": null,
        "args": null,
        "concreteType": "TranslationAnswer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateTranslationAnswerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateTranslationAnswerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateTranslationAnswerMutation",
    "id": null,
    "text": "mutation CreateTranslationAnswerMutation(\n  $input: CreateTranslationAnswerInput!\n) {\n  createTranslationAnswer(input: $input) {\n    answer {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '5c0fc22577af9dc43c91437b8c47b40d';
export default node;
